import React from 'react'
import styled from '@emotion/styled'
import { BreakPoint } from 'src/components/shared/CssValues'
import { navigate } from 'gatsby'
import { Typography } from './Typography'

const ImageCard = props => {
  const handleClick = () => {
    navigate(props.linkTo)
  }
  return (
    <Card onClick={handleClick}>
      <TopImage src={props.ImageTop} />
      <LogoContainer>
        <LogoImage src={props.ImageLogo} />
      </LogoContainer>
      <Title as="p">{props.title}</Title>
      <Text as="p">{props.text}</Text>
    </Card>
  )
}

const Card = styled.div`
  position: relative;
  width: 100%;
  padding: 25px 0 60px;
  box-sizing: border-box;
  background-color: #ffffff;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.15);
  cursor: pointer;
  text-align: center;

  margin: 0px auto 10px;
  @media screen and (min-width: ${BreakPoint.TABLET_MIN_WIDTH}) {
    width: 31.313%;
  }
`

const TopImage = styled.img`
  object-fit: contain;
  margin: 0 auto;
  aspect-ratio: 40 / 21;
  max-width: 90%;
`

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  padding: 25px 50px;
  @media screen and (min-width: ${BreakPoint.MOBILE}) {
    padding: 25px;
  }
  @media screen and (min-width: ${BreakPoint.TABLET}) {
    padding: 25px 50px;
  }
`

const LogoImage = styled.img`
  max-width: 100%;
  max-height: 100%;
  display: inline !important;
`

const Title = styled(Typography)`
  font-size: 14px;
  font-stretch: normal;
  font-style: normal;
  line-height: 2;
  letter-spacing: 1.12px;
  text-align: left;
  color: #333333;
  margin: 10px;
`

const Text = styled(Typography)`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 25px;
  margin: auto;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.2;
  letter-spacing: 1.12px;
  color: #333333;
  display: block;
`

export default ImageCard
